import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_006",
  "use": "icon-wo_006-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_006\"><defs><style>#icon-wo_006 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_006_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_006_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M3,3V21H21V3ZM13,17H7V15h6Zm4-4H7V11H17Zm0-4H7V7H17Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol